import { AppConfiguration } from './configuration.model';

export const configurationsProd: AppConfiguration = {
  appConfigUri: 'https://raw.githubusercontent.com/PiCake314/cpp-quiz-db/main/questions.json'
}